import React from "react";

const ContextDefault = React.createContext();
const ConsumerDefault = ContextDefault.Consumer;
class ProviderDefault extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      minAmount: 20,
      showProgressBar: false,
      progressFrom: 0,
      progressTo: 0,
      text: "1/5",
      donate: {
        profile: "", //pf / pj
        frequency: "", //monthly / once
        amount: 0,
        installments: 0,
        firstName: "",
        surname: "",
        razaoSocial: "",
        contactPerson: "",
        cpf: "",
        cnpj: "",
        phone: "",
        email: ""
      }
    };

    this.actions = {
      setDonate: (prop, value) => {
        this.setState(prev => {
          return {
            donate: {
              ...prev.donate,
              [prop]: value
            }
          };
        });
      },

      setProgressBarVisiblity: value => {
        this.setState({ showProgressBar: value });
      },

      setProgressConfig: (showProgressBar, progressTo, text, progressFrom) => {
        this.setState({
          showProgressBar: showProgressBar,
          progressTo: progressTo,
          text: text,
          progressFrom: progressFrom
        });
      }
    };
  }

  render() {
    return (
      <ContextDefault.Provider
        value={{
          state: this.state,
          actions: this.actions
        }}
      >
        {this.props.children}
      </ContextDefault.Provider>
    );
  }
}

export { ConsumerDefault, ContextDefault, ProviderDefault };
